// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import { MeDynamicReportService } from '../dynamic-report.service';

@Component({
    selector: 'me-dynamic-overview-card',
    templateUrl: './overview-card.component.html',
    styleUrls: ['./overview-card.component.scss'],
    providers: [MeDynamicReportService]
})

export class MeDynamicOverviewCardComponent implements OnInit {
    data: any;
    url = 'dynamic-report/overview-card';
    items = [];
    clusters = [];
    totalValue = 0;

    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public router: Router,
        public meDynamicReportService: MeDynamicReportService
    ) {
       
    }

    ngOnInit() {
        this.getOverviewCard();
        this.translate.onLangChange.subscribe(value => {
            this.getOverviewCard();
        });
    }

    getOverviewCard() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.getDynamicReport();
        });
    }

    getDynamicReport() {
        this.meDynamicReportService.getDynamicReport().subscribe(res => {
            this.items = res['items'];
            this.clusters = res['clusters'];
            this.formatClusterData();
            this.appService.isLoading = false;
        });
    }

    formatClusterData() {
        this.clusters.forEach(cluster => {
            this.totalValue += cluster.value;
        });

        this.clusters.forEach(cluster => {
            cluster.percent = Math.round((cluster.value / this.totalValue) * 100);
        });
    }
}
